// export const API_BASE_URL = 'http://192.168.1.90:8080/api';
// export const BE_BASE_URL = 'http://192.168.1.90:8080/';
export const API_BASE_URL = 'https://addaappsbe.rsudciracas.co.id/api';
export const FE_BASE_URL = 'https://addaappsfe.rsudciracas.co.id/';
export const BE_BASE_URL = 'https://addaappsbe.rsudciracas.co.id/';
// export const FE_BASE_URL = 'http://localhost:3000';

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}